import { Search, X } from 'lucide-react';
import { useFilterStore } from '../store/useFilterStore';

export function SearchBar() {
  const { searchQuery, setSearchQuery } = useFilterStore();

  return (
    <div className="relative">
      <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5" style={{ color: '#9E9E9E' }} />
      <input
        type="text"
        placeholder="Search by symbol or company name..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="w-full pl-12 pr-12 py-3 border rounded-lg focus:outline-none focus:ring-2 transition-all min-h-[44px] text-sm sm:text-base"
        style={{
          backgroundColor: '#1E1E1E',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          borderColor: 'rgba(255, 255, 255, 0.1)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          color: '#F9F9F9'
        }}
      />
      {searchQuery && (
        <button
          onClick={() => setSearchQuery('')}
          className="absolute right-4 top-1/2 -translate-y-1/2 transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
          style={{ color: '#9E9E9E' }}
          onMouseEnter={(e) => e.currentTarget.style.color = '#F9F9F9'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#9E9E9E'}
        >
          <X className="w-5 h-5" />
        </button>
      )}
    </div>
  );
}

